// =============================================================================
// SettingsSkeleton.jsx - Loading Skeleton Component
// =============================================================================
// Extracted from Settings.jsx to show loading state while settings load
// =============================================================================

import React from 'react';

// =============================================================================
// SETTINGS SKELETON COMPONENT
// =============================================================================
const SettingsSkeleton = () => (
  <div style={{ animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }}>
    {/* Title Skeleton */}
    <div style={{ 
      height: '32px', 
      backgroundColor: '#e5e7eb', 
      borderRadius: '8px', 
      width: '200px', 
      marginBottom: '16px' 
    }}></div>
    
    {/* Buttons Skeleton */}
    <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
      <div style={{ height: '40px', backgroundColor: '#e5e7eb', borderRadius: '6px', width: '120px' }}></div>
      <div style={{ height: '40px', backgroundColor: '#e5e7eb', borderRadius: '6px', width: '120px' }}></div>
      <div style={{ height: '40px', backgroundColor: '#e5e7eb', borderRadius: '6px', width: '120px' }}></div>
    </div>
    
    {/* Large Content Block Skeleton */}
    <div style={{ backgroundColor: '#e5e7eb', borderRadius: '12px', height: '300px', marginBottom: '24px' }}></div>
    
    {/* Medium Content Block Skeleton */}
    <div style={{ backgroundColor: '#e5e7eb', borderRadius: '12px', height: '200px' }}></div>
    
    {/* Pulse Animation */}
    <style>{`
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
    `}</style>
  </div>
);

export default SettingsSkeleton;
